export const isCtrl = (ke: KeyboardEvent) =>
  (ke && (ke.ctrlKey && (ke.key == 'Control' || ke.code.includes('Control') || ke.keyCode == 17 || ke.which == 17))) ||
  false;
export const isAlt = (ke: KeyboardEvent) =>
  (ke && (ke.altKey && (ke.key == 'Alt' || ke.code.includes('Alt') || ke.keyCode == 18 || ke.which == 18))) || false;
export const isShift = (ke: KeyboardEvent) =>
  (ke && (ke.shiftKey && (ke.key == 'Shift' || ke.code.includes('Shift') || ke.keyCode == 16 || ke.which == 16))) ||
  false;
export const isEscape = (ke: KeyboardEvent) =>
  (ke && ke.key == 'Escape') || ke.code == 'Escape' || ke.keyCode == 27 || ke.which == 27 || false;
export const isCtrlC = (ke: KeyboardEvent) =>
  (ke &&
    (ke.ctrlKey &&
      (ke.keyCode == 67 || ke.key == 'c' || ke.code == 'KeyC') &&
      !(ke.altKey || ke.shiftKey || isEscape(ke)))) ||
  false;

export const isAltLeftArrow = (ke: KeyboardEvent) =>
  (ke.altKey && (ke.code == 'AltLeft' || ke.keyCode == 18 || ke.which == 18) && !(ke.shiftKey || ke.ctrlKey)) || false;
// ArrowLeft
